import { render, staticRenderFns } from "./topHeader_h5.vue?vue&type=template&id=fd0f5df2&scoped=true"
import script from "./topHeader_h5.vue?vue&type=script&lang=js"
export * from "./topHeader_h5.vue?vue&type=script&lang=js"
import style0 from "./topHeader_h5.vue?vue&type=style&index=0&id=fd0f5df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd0f5df2",
  null
  
)

export default component.exports